import { render } from "./OnboardingComplete.vue?vue&type=template&id=eded66ae&ts=true"
import script from "./OnboardingComplete.vue?vue&type=script&lang=ts"
export * from "./OnboardingComplete.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__